import { render, staticRenderFns } from "./SubscriptionFlag.vue?vue&type=template&id=3105c62c&scoped=true&"
import script from "./SubscriptionFlag.vue?vue&type=script&lang=js&"
export * from "./SubscriptionFlag.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionFlag.vue?vue&type=style&index=0&id=3105c62c&lang=scss&scoped=true&"
import style1 from "./SubscriptionFlag.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3105c62c",
  null
  
)

export default component.exports